<template>
  <div
    :class="{
      'message': true,
      'message--grid': this.grid,
      'message--can-close': this.canClose,
      ...objectModifiers
    }"
    v-show="show"
  >
    <slot />
    <button v-if="canClose" @click="onClose">
      <sprite id="app/close" class="message__close" />
    </button>
  </div>
</template>

<script>
import Sprite from "@/shared/sprite"
import { cookie } from "@/utils/cookie"
import "@wds/bin/sprites/app/close.svg"

const COOKIE_DURATION = 90

export default {
  name: "Message",
  components: { Sprite },
  model: {
    name: "show",
    event: "close"
  },
  props: {
    canClose: { type: Boolean, default: false },
    cookie: { type: String, default: null },
    modifiers: { type: Array, default: () => [] },
    // If you turn grid on, you may want to add a $spacing-16 padding
    // to elements flexed at the start and / or at the end of it
    grid: { type: Boolean, default: false },
    show: { type: Boolean, default: true }
  },
  computed: {
    objectModifiers() {
      return this.modifiers.reduce((object, value) => {
        object[`message--${value}`] = true
        return object
      }, {})
    }
  },
  mounted() {
    if (this.canClose && this.cookie && cookie(this.cookie)) {
      this.$emit("close")
    }
  },
  methods: {
    onClose: function () {
      if (this.cookie) {
        cookie(this.cookie, 1, COOKIE_DURATION)
      }
      this.$emit("close")
    }
  }
}
</script>

<style lang="scss">
.message {
  position: relative;

  padding: $spacing-16;

  background-color: $pale-mint-grey;

  border-radius: $spacing-4;

  &--can-close {
    padding-right: $spacing-48;
  }

  &__close {
    position: absolute;
    top: $spacing-16;
    right: $spacing-16;

    width: $spacing-16;

    color: $grey;

    cursor: pointer;
  }

  &--grid {
    @include grid-css;

    padding-right: 0;
    padding-left: 0;
  }

  &--background-blue {
    background-color: $background-blue;
  }

  &--background-red {
    background-color: $background-red;
  }

  &--background-green {
    background-color: $background-green;
  }

  &--background-yellow {
    background-color: $yellow4;
  }
}
</style>
